import React, { useEffect, useState } from 'react'
import { ArrowBackOutlined } from '@material-ui/icons'
import { getTime } from 'components/AlertNotification/utils'
import { Button, Card, Col, Container, Form, ListGroup, Row, Spinner } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'
import FileUploadMultiple from 'components/FileUploadMultiple'
import Loading from 'components/Loading'
import TicketRequestService from 'services/ticket-request'
import { useUser } from 'models'

export default function () {
  const { id } = useParams()
  const history = useHistory()

  const user = useUser()

  const [subject, setSubject] = useState("")
  const [categoryId, setCategory] = useState("")
  const [priorityId, setPriority] = useState("")
  const [description, setDescription] = useState("")
  const [comment, setComment] = useState("")
  const [files, setFiles] = useState([])
  const [existingFiles, setExistingFiles] = useState([])
  const [comments, setComments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [isSavingComment, setIsSavingComment] = useState(false)
  const [categories, setCategories] = useState([])
  const [priorities, setPriorities] = useState([])

  useEffect(() => {
    getCategories()
    getPriorities()
    if (id) {
      getTicket()
    }
  }, [])

  function getCategories() {
    TicketRequestService.getCategories()
      .then(({ data }) => {
        setCategories(data)
      })
  }

  function getPriorities() {
    TicketRequestService.getPriorities()
      .then(({ data }) => {
        setPriorities(data)
      })
  }

  function getTicket() {
    TicketRequestService.getTicket(id)
      .then(({ data }) => {
        setSubject(data.subject)
        setCategory(data.type_id)
        setPriority(data.priority_id)
        setDescription(data.description)
        setComments(data.comments)
        setExistingFiles(data.files.map(file => ({ ...file, comment: file.name, uri: file.url })))
      })
  }

  function handleSubmit() {
    setIsSending(true)
    const formData = new FormData()
    formData.append('subject', subject)
    formData.append('type_id', categoryId)
    formData.append('priority_id', priorityId)
    formData.append('description', description)

    for (let i in files) {
      formData.append(`files[${i}]`, files[i])
    }

    let request

    if (id) request = TicketRequestService.update(id, formData)
    else request = TicketRequestService.store(formData)
    
    request.then(() => {
      history.goBack()
    })
    .finally(() => setIsSending(false))
  }

  function handleSaveComment() {
    setIsSavingComment(true)
    TicketRequestService.storeComment(id, { comment })
      .then(() => {
        getTicket()
        setComment("")
      })
      .finally(() => setIsSavingComment(false))
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Col>
          <Button variant="link" onClick={() => {
            history.goBack()
          }}>
            <ArrowBackOutlined /> Voltar
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={id ? 8 : 12}>
          <Card.Body className="shadow bg-white rounded text-left m-2">
            {isLoading ? (<Loading page />) : (<>
              <Form>
                <Row>
                  <Col xl="12">
                    <Form.Group>
                      <Form.Label>Assunto:</Form.Label>
                      <Form.Control type="input" value={subject} onChange={e => setSubject(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col xl="6">
                    <Form.Group>
                      <Form.Label>Categoria:</Form.Label>
                      <Form.Control
                        as="select"
                        value={categoryId}
                        onChange={e => setCategory(e.target.value)}
                      >
                        <option selected>Selecione uma opção</option>
                        {categories.map(cat => {
                          return (
                            <option key={cat.id} value={cat.id} >{cat.name}</option>
                          )
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xl="6">
                    <Form.Group>
                      <Form.Label>Prioridade:</Form.Label>
                      <Form.Control
                        as="select"
                        value={priorityId}
                        onChange={e => setPriority(e.target.value)}
                      >
                        <option selected>Selecione uma opção</option>
                        {priorities.map(priority => {
                          return (
                            <option key={priority.id} value={priority.id}>{priority.name}</option>
                          )
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xl="12">
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                      <Form.Label>Descricao:</Form.Label>
                      <Form.Control
                        rows={3}
                        as="textarea"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col xl="12">
                    <Form.Group>
                      <Form.Label>Arquivos:</Form.Label>
                      <FileUploadMultiple
                        existingFiles={existingFiles}
                        files={[...files]}
                        setFiles={files => setFiles(files)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col>
                  {isSending ? (
                    <Spinner animation="border" style={{ color: '#e05c17' }} />
                  ) : (
                    <Button className="btn-add" onClick={() => handleSubmit()}>{id ? 'Salvar' : 'Enviar Solicitacao' }</Button>
                  )}
                </Col>
              </Row>
            </>)}
          </Card.Body>
        </Col>
        {id && (
          <Col md="4">
            <Card.Body className="shadow bg-white rounded text-left m-2">
              <Row>
                <Col md="12">
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Control
                        as="textarea"
                        value={comment}
                        rows={3}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </Form.Group>
                    <Row>
                      <Col>
                        {isSavingComment ? (
                          <Spinner animation="border" style={{ color: '#e05c17' }} />
                        ) : (
                          <Button onClick={() => handleSaveComment()} variant='primary' size="sm">
                            Salvar
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                  {comments.length > 0 && <hr />}
                </Col>
                {comments.length > 0 && (<>
                  <Col md="12">
                    <ListGroup variant="flush">
                      {comments.map(comment => (
                        <ListGroup.Item>
                          <div>
                            <span>
                              <b>{comment.user.full_name}:{' '}</b>
                              <small className='font-italic'>{getTime(comment.created_at, true)}</small>
                            </span>
                            <p className='text-muted'>
                              <small>{comment.body}</small>
                            </p>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </Col>
                </>)}
              </Row>
            </Card.Body>
          </Col>
        )}
      </Row>
    </Container>
  )
}